import { render, staticRenderFns } from "./newComerGiftPack.vue?vue&type=template&id=0de74085&scoped=true&"
import script from "./newComerGiftPack.vue?vue&type=script&lang=ts&"
export * from "./newComerGiftPack.vue?vue&type=script&lang=ts&"
import style0 from "./newComerGiftPack.vue?vue&type=style&index=0&id=0de74085&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de74085",
  null
  
)

export default component.exports